import {memo} from "react";
import MenuItem, {MenuItemProps} from "./MenuItem";
import {List} from "@material-tailwind/react";

interface MenuProps {
    list: MenuItemProps[],
    className?: string
}

const Menu = ({list, className}: MenuProps) => {
    return (
        <List className={className ?? ''}>
            {list.map(item => <MenuItem key={item.name.toLowerCase()} {...item}/>)}
        </List>
    );
}

export default memo(Menu);
